import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthService } from '@wgu-edu/wgu-core';


@Component({
  selector: 'nav-bar',
  templateUrl: './template/nav-bar.component.html',
  styleUrls: ['./template/nav-bar.component.scss']
})
export class NavBarComponent {
  isAuthenticated$: Observable<boolean>;
  username: string;

  constructor(private authService: AuthService, private router: Router) {
    this.isAuthenticated$ = this.authService.isAuthenticated$;
    this.username = 'fake.user'
  }
}
